import React, { forwardRef } from 'react';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';

import styles from './CustomCheckBox.module.scss';

const cx = classnames.bind(styles);

const CustomCheckBox = forwardRef(({
   className = '',
   label,
   name,
   checked = false,
   onChange = () => {},
   onBlur = () => {},
   bold = false,
   ...rest
}, ref) => {

  return (
    <label
      className={cx('check-box', className, { bold }, checked && 'checked')}
    >
      <input
        ref={ref}
        className={cx('check-box__input')}
        type="checkbox"
        name={name}
        checked={checked}
        onChange={onChange}
        onBlur={onBlur}
        {...rest}
      />
      <span className={cx('check-box__label')}>
        {label}
      </span>
    </label>
  );
});

CustomCheckBox.displayName = 'CustomCheckBox';

CustomCheckBox.propTypes = {
  className: PropTypes.string,
  label: PropTypes.node,
  name: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  bold: PropTypes.bool,
};

export default CustomCheckBox;
